import { useSyncExternalStore } from 'react';

type FormGuardState = {
  /**
   * Глобальный флаг наличия несохранённых изменений на текущей странице.
   *
   * Управляется формами/карточками через entities/formGuard.
   */
  isDirty: boolean;
  /**
   * Временное разрешение навигации для системных переходов.
   *
   * Используется safeNavigate для обхода блокировки при save/create редиректах.
   */
  allowNavigation: boolean;
};

type FormGuardListener = () => void;

type FormGuardStore = {
  getState: () => FormGuardState;
  setState: (partial: Partial<FormGuardState>) => void;
  subscribe: (listener: FormGuardListener) => () => void;
};

const initialState: FormGuardState = {
  isDirty: false,
  allowNavigation: false,
};

let state: FormGuardState = initialState;
const listeners = new Set<FormGuardListener>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const formGuardStore: FormGuardStore = {
  getState: () => state,
  setState: (partial) => {
    state = { ...state, ...partial };
    notify();
  },
  subscribe: (listener) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};

export const resetFormGuardState = () => {
  state = initialState;
  notify();
};

export const useFormGuardStore = () => {
  return useSyncExternalStore(formGuardStore.subscribe, formGuardStore.getState, formGuardStore.getState);
};
